// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + {"446": "recorder","890": "profiler",}[chunkId] + "-internal-8dea7e3b-ae85-4c0f-8f42-cf7f6172d1a0-" + {"446": "08c45d4e96358715","890": "32c2d1081a4f9e4e",}[chunkId] + ".js"
}